import { apiClient, API_ENDPOINTS } from '../../../lib';
import type { QuerySitesResponse, Site } from '@wix/ambassador-site-list-v2-site/types';

export async function querySites(metaSiteId: string): Promise<Site | null> {
  try {
    const response = await apiClient.post<QuerySitesResponse>(API_ENDPOINTS.site.querySites, {
      metaSiteId,
    });
    return response.sites?.[0] || null;
  } catch (error) {
    console.error('Failed to query sites:', error);
    return null;
  }
}
